(function() {

    'use strict';

    angular.module('Services').factory('TruckInformationAuditTable', TruckInformationAuditTable);

    TruckInformationAuditTable.$inject = [
        'TruckInformationAuditService',
        'TableLiteFactory',
        'ConfirmationModalFactory',
        'toastr',
        '$location',
        '$rootScope',
        '$filter',
        '$uibModal'
    ];
    function TruckInformationAuditTable(
        TruckInformationAuditService,
        TableLiteFactory,
        ConfirmationModalFactory,
        toastr,
        $location,
        $rootScope,
        $filter,
        $uibModal
    ) {

        return function () {
            const viewConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.ftpImportNow.MESSAGE',
                code: 'messages.warning.ftpImportNow.CODE',
            });
            var tableData = {
                tableName: 'TruckinformationTable',

                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    colMinWidth: '135px'
                },
                headers: [{
                    label: "Date Loaded",
                    viewName: "DateLoaded",
                    filterName: "createdDate",
                    filter: {
                        type: 'datePicker',
                        placeholder: "",
                        onSubmit: header=>{
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Manifested No.',
                    viewName: 'manifestNo',
                    filterName: 'truckDriverAuditShipmentDetailSet.manifestNo',
                    filter: {
                        type: "text",
                        placeholder: "Search",
                        onSubmit: header=>{
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: "Carrier Profile",
                    viewName: "carrierProfileName",
                    filterName: "carrierProfileName",
                    filter: {
                        type: "text",
                        placeholder: "Search",
                        onSubmit: header=>{
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },{
                    label: 'No. of Shipment',
                    viewName: 'noOfShipment',
                    filterName: 'noOfShipment',
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                },{
                    label: 'No. of Packages',
                    viewName: 'packageNo',
                    filterName: 'noOfPackage',
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                },{
                    label: 'Driver',
                    viewName: 'driverName',
                    filterName: 'driverName',
                    filter: {
                        type: "text",
                        placeholder: "Search",
                        onSubmit: header=>{
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Driver Phone',
                    viewName: 'driverPhone',
                    filterName: 'driverPhone',
                    filter: {
                        type: "text",
                        placeholder: "Search",
                        onSubmit: header=>{
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: "Plate Number",
                    viewName: "plateNumber",
                    filterName: "plateNumber",
                    filter: {
                        type: "text",
                        placeholder: "Search",
                        onSubmit: header=>{
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'ACTIONS',
                    viewName: 'actions',
                    filterName: 'actions',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }],
                data: []
            };
            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: TruckInformationAuditService.getTruckInformationAudit,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        const TruckTableData = TruckInformationAuditService.truckDriverInformationAudit(data)
                        buildTableData(TruckTableData);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters : {
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    let date = new Date(item.DateLoaded)
                    const timeZone = date.toLocaleTimeString('en-us',{timeZoneName:'short'}).split(' ')[2];
                    const dateFormatted = $filter('bbaDate')(item.DateLoaded);
                    const hour = date.getHours();
                    const min = date.getMinutes();
                    item.DateLoaded = `${dateFormatted}`;
                    item.importStatusFormatted = `${item.imported} IMPORTED, ${item.failed} FAILED`;
                    item.commentsFormatted = item.comments || 'N/A';
                    item.manifestNo = item.manifestNo;
                    item.packageNo = item.packageNo;
                    item.actions = {
                        type: 'button',
                        buttons: [{
                            text: 'View Shipments',
                            class: 'btn btn-primary',
                            action: row => {
                                $location.path(`/truck-information-audit/${item.id}`)
                            },
                        },{
                            text: 'View Details',
                            class: 'btn btn-warning',
                            action: row => {
                                showDriverDetailsModal(item.driverDetails)
                            }
                        }
                        ]
                    };
                    tableData.data.push(item);
                });
            };

            function showDriverDetailsModal(data) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'r-c-p-modal',
                    templateUrl: '/templates/pages/manifests/modal/driverDetailsModal.html',
                    controller: 'DriverDetailsModalController',
                    controllerAs: 'vm',
                    size: 'md',
                    appendTo: $('body'),
                    resolve: {
                        data: function () {
                            return angular.copy(data)
                        }
                    },

                });

                modalInstance.result.then(function (data) {
                    // add here
                }, function () {
                });

                // vm.schedModalForm.frequency = angular.copy(vm.weekDays);
            }

            this.tableData = tableData;
        };
    }

})();




// WEBPACK FOOTER //
// ./js/services/tables/manifests/TruckInformationAuditTable.js